import { ColumnDef } from "@tanstack/react-table";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const TotalReferralsCol = (): ColumnDef<AccountTableUser> => ({
  header: "Referrals",
  accessorFn: (row) => row.stats?.total_referral_count ?? 0,
  cell: ({ getValue }) => (
    <span className="tabular-nums">{getValue() as number}</span>
  ),
  size: 100,
});
